import _ from 'lodash';

function tabulateDemographics(demographics) {
  const demographicsTable = {};
  const AGE_BUCKET_REGEX = /([a-zA-Z])+/gi;
  const total = {
    M: 0,
    F: 0,
  };
  _.map(demographics, (value, key) => {
    const [gender, ageGroup] = _.tail(_.split(key, AGE_BUCKET_REGEX));
    total[gender] += value.percentage;
    if (!demographicsTable[ageGroup]) {
      demographicsTable[ageGroup] = {};
    }
    demographicsTable[ageGroup][gender] = value;
  });
  const demographicsArray = Object.entries(demographicsTable);
  console.log(demographicsArray);
  demographicsArray.sort((a, b) => {
    const [aValue] = _.tail(a);
    const [bValue] = _.tail(b);
    return (bValue.M.percentage + bValue.F.percentage) -
    (aValue.M.percentage + aValue.F.percentage);
  });
  console.log(total);
  return {
    demographicsTable: demographicsArray,
    total,
  };
}

module.exports = {
  tabulateDemographics,
};




/** WEBPACK FOOTER **
 ** ./src/utils/demographics-functions.js
 **/